import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiInterface } from 'src/app/api-interface';
import AlertifyHelper from 'src/app/utils/utils';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  constructor(private restService: RestService) {}
  
  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('product/list', val_params);
  }

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('product/search', val_params);
  }

  searchAll(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('product/search_all', val_params);
  }

  searchSale(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('product/sale/search', val_params);
  }

  listFavorite(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('product/favorite', val_params);
  }

  get(val_id: number) {
    return this.restService.get('product/edit', val_id);
  }

  getInformationDetail(val_id: number) {
    return this.restService.get('product/information/detail', val_id);
  }

  getBatchExpiration(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('product/batch/expiration', val_params);
  }


  updateSave(data: any) {
    return this.restService.save('product/update/save', data);
  }

  save(data: any) {
    return this.restService.save('product/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('product/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('product/delete', val_id);
  }
}
